import React from "react";
import { useSelector } from "react-redux";
import { Box, Stack } from "@mui/material";
import ShepSearchbar from "@/components/GenericComponents/ShepSearchBar";
import {
  selectEditConnectionEndpoints,
  selectEditConnectionEndpointsLoaded,
} from "@/features/connections/integrationSlice";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import ShepTable from "@/components/GenericComponents/ShepTable";

const Endpoints = ({
  selectedEndpointId,
  setSelectedEndpointId,
  setEndpointHasErrors,
}) => {
  const apiRef = useGridApiRef();
  const recordLoaded = useSelector(selectEditConnectionEndpointsLoaded);
  const rows = useSelector(selectEditConnectionEndpoints);

  const columns = [
    {
      field: "EndpointName",
      headerName: "Endpoint Name",
      width: 500,
    },
    {
      field: "AppTypeLabel",
      headerName: "Type",
      width: 220,
    },
  ];

  return (
    <Box
      sx={{ display: "block", flexDirection: "column" }}
      aria-label="Endpoints container"
    >
      <Stack
        direction="row"
        style={{ display: "flex", paddingBottom: 25 }}
        aria-label="Search bar container"
      >
        <ShepSearchbar
          placeholder="Search by Endpoint Name or Type"
          onChange={(event) => {
            if (apiRef.current) {
              apiRef.current.setQuickFilterValues([event.target.value]);
            }
          }}
          sx={{
            width: "350px",
            paddingLeft: "20px",
          }}
          aria-label="Search by Endpoint Name or Type"
        />
      </Stack>
      <Box
        className="content-box"
        sx={{ display: "flex", flexDirection: "row" }}
        aria-label="Content box"
      >
        <Box sx={{ width: "100%" }} aria-label="Data grid container">
          <Box
            sx={{
              borderRadius: 5,
              backgroundColor: "white",
              marginBottom: 5,
            }}
            aria-label="Data grid box"
          >
            <ShepTable
              tableTitle="Endpoints"
              isDataLoaded={recordLoaded}
              apiRef={apiRef}
              dataRows={rows}
              columnTitles={columns}
              handleSelectedRowChange={(rowSelectionModel) => {
                const selectedId = parseInt(rowSelectionModel[0]);
                // SHEP-416 Bonus Task - Best effort fix to prevent overriding selectedEndpointId when table initializes
                if (isNaN(selectedId)) return;

                if (selectedId === selectedEndpointId) {
                  setSelectedEndpointId(null);
                } else {
                  setSelectedEndpointId(selectedId);
                }
              }}
              selectedRow={selectedEndpointId ? [selectedEndpointId] : []}
              emptyMessage={{
                title: "No Endpoints",
                message: "Add an endpoint first",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default Endpoints;
